import React, { use, useState } from "react";
import Sidebar from "../../../components/Sidebar";
import TopBar from "../../../components/TopBar";
import MemberDetails from "../../../components/MemberDetails/MemberDetails";
import { useNavigate } from "react-router-dom";

export default function Index() {
  const [collapsed, setCollapsed] = useState(false);
  const navigate =  useNavigate();
  const handleBack = () => {
    console.log("Back clicked");
    navigate("/members");
  };

  const handleClose = () => {
    console.log("Close clicked");
      navigate("/members");
  };

  const handleShare = () => {
    console.log("Share clicked");
  };

  const handleExport = () => {
    console.log("Export clicked");
  };
  return (
    <div className="fixed inset-x-0 bottom-0 top-16 flex bg-[#F8FAFC] overflow-hidden">
      <TopBar />

      {/* Sidebar */}
      <div
        className={`hidden lg:flex ${collapsed ? "w-[64px]" : "w-[272px]"} fixed top-0 left-0 h-screen z-20`}
      >
        <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
      </div>
      <div
        className={`flex-1 min-w-0 font-poppins overflow-auto bg-[#F8FAFC] pt-2 px-2 pb-8 transition-all duration-300 ${
          collapsed ? "lg:ml-[64px]" : "lg:ml-[272px]"
        }`}
      >
        <div className="p-4 md:p-6 bg-[#FFFFFF] min-h-screen rounded-2xl">
          <div className="w-full bg-[#FFFFFF] rounded-xl">
            <MemberDetails
              onBack={handleBack}
              onClose={handleClose}
              onShare={handleShare}
              onExport={handleExport}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
